import { StripeEnv } from '../../util/enums';
import { vaultRequest } from './request';

const CREATE_CUSTOMER_MUTATION = `
mutation VaultCustomerCreate(
    $payableOrgName: String!
    $stripeEnv: VaultStripeEnv
  ) {
    customerId: vaultCustomerCreate(payableOrgName: $payableOrgName, stripeEnv: $stripeEnv)
  }
`;

export const createCustomer = async (customer: {
  payableOrgName: string;
  stripeEnv: StripeEnv;
}): Promise<string> => {
  const customerRes = await vaultRequest(CREATE_CUSTOMER_MUTATION, customer);

  const customerJson = await customerRes.json();
  if (customerJson.errors) {
    throw new Error(`Could not create customer for ${customer.payableOrgName}`);
  }
  return customerJson.data.customerId;
};
